import * as React from "react";
import { Popup } from "semantic-ui-react";
import styles from "./MenuButton.module.scss";

import copy from "../../images/copy.svg";
import paste from "../../images/paste.svg";
import trash from "../../images/trash.svg";
import cross from "../../images/cross.svg";
import check from "../../images/check.svg";
import checkDisabled from "../../images/check-gray.svg";
import service from "../../images/service.svg";
import add from "../../images/circle-plus.svg";
import edit from "../../images/PCBA.svg";
import open from "../../images/open-file.svg";
import close from "../../images/Close-icon.svg";



export type MenuButtonProps = {
  type: "Add" | "Delete" | "Cancel" | "Copy" | "Paste" | "Save" | "Settings" | "Edit" | "Open" | "Close";
  source?: string;
  handleOnClick: () => void;
  disabled?: boolean;
  showtext?: boolean;
  customText?: string;
};

/** Add component (button) */
const MenuButton: React.FC<MenuButtonProps> = ({
  type,
  source,
  handleOnClick,
  disabled,
  showtext,
  customText
}) => {
  const buttonText = customText ? customText.toUpperCase() : type.toUpperCase();
  let icon;
  const classes = [styles.MenuButtonWrapper];
  if (disabled) {
    classes.push(styles.Disabled);
    classes.push("disabled");
  }
  switch (type) {
    case "Add":
      icon = add;
      break;
    case "Edit":
      icon = edit;
      break;
    case "Cancel":
      icon = cross;
      break;
    case "Delete":
      icon = trash;
      break;
    case "Copy":
      icon = copy;
      break;
    case "Paste":
      icon = paste;
      break;
    case "Save":
      icon = disabled ? checkDisabled : check;
      break;
    case "Settings":
      icon = service;
      break;
    case "Open":
      icon = open;
      break;
      case "Close":
        icon = close;
        break;

    default:
      break;
  }

  return (
    <Popup
      trigger={
        <div
          id={type}
          className={classes.join(" ")}
          onClick={
            disabled
              ? () => {
                  /*  */
                }
              : handleOnClick
          }
        >
          <img className={styles.icon} src={icon} alt={type} />
          {(showtext || !!customText) && <span>{buttonText}</span>}
        </div>
      }
      content={
        <span>
          {type} {disabled ? "Disabled" : ""} {source}
        </span>
      }
    />
  );
};

export default MenuButton;

